// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y3S9","field":"styles_field__OePfd","fieldCol":"styles_fieldCol__1K0kX","diffCol":"styles_diffCol__3vawR","diff":"styles_diff__19WIM"};